import { render, staticRenderFns } from "./JdiDocs.vue?vue&type=template&id=e0f5d99a&scoped=true&"
import script from "./JdiDocs.vue?vue&type=script&lang=ts&"
export * from "./JdiDocs.vue?vue&type=script&lang=ts&"
import style0 from "./JdiDocs.vue?vue&type=style&index=0&lang=css&"
import style1 from "./JdiDocs.vue?vue&type=style&index=1&id=e0f5d99a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f5d99a",
  null
  
)

export default component.exports